import React, { useContext } from 'react';

type CustomTrackPayload = {
  event: MouseEvent | React.MouseEvent<HTMLElement>;
  identifier?: string;
  element?: string;
  detail?: string;
};

type AnalyticsContextType = {
  customTrack: (payload: CustomTrackPayload) => void;
  identifier?: string;
};

export const analyticsContext = React.createContext<
  AnalyticsContextType | undefined
>(undefined);

export const useAnalyticsContext = (): AnalyticsContextType => {
  const context = useContext(analyticsContext);

  if (!context) {
    throw new Error(
      'useAnalyticsContext must be used within an AnalyticsContext provider'
    );
  }

  return context;
};
